import React, { useCallback } from 'react'
import { Navigate, NavigateOptions, NavigateProps, useLocation, useNavigate } from 'react-router-dom'

import { useFeatureBasename } from './CoreContextBrowserRouter'

export const useFeatureNavigation = () => {
  const routerNavigate = useNavigate()
  const basename = useFeatureBasename()
  const { search } = useLocation()
  const buildFeatureUrl = useCallback(
    (to: string, skipSearch = false) => {
      const path = `${basename}${to.startsWith('/') ? to : `/${to}`}`
      if (skipSearch || to.includes('?')) return path
      const hashIndex = path.indexOf('#')
      return hashIndex < 0 ? `${path}${search}` : `${path.slice(0, hashIndex)}${search}${path.slice(hashIndex)}`
    },
    [basename, search]
  )
  const navigate = useCallback(
    (to: string | number, options?: NavigateOptions) => {
      if (typeof to === 'number') routerNavigate(to)
      else routerNavigate(buildFeatureUrl(to), options)
    },
    [routerNavigate, buildFeatureUrl]
  )

  return { buildFeatureUrl, navigate }
}

export const FeatureNavigate: React.FC<Omit<NavigateProps, 'to'> & { to: string }> = ({ to, ...props }) => {
  const { buildFeatureUrl } = useFeatureNavigation()
  return <Navigate {...props} to={buildFeatureUrl(to)} />
}
